import React from 'react';
import { Modal } from 'antd';
import FeeScheduleHistory from './FeeScheduleHistory';

interface FeeScheduleHistoryModalProps {
  visible: boolean;
  onClose: () => void;
  posDeviceId: number;
  cardTypeId: number;
  cardTypeName: string;
  bankId?: number | null;
  bankName?: string;
}

const FeeScheduleHistoryModal = ({
  visible,
  onClose,
  posDeviceId,
  cardTypeId,
  cardTypeName,
  bankId,
  bankName,
}: FeeScheduleHistoryModalProps) => {
  return (
    <Modal
      open={visible}
      title="Lịch sử biểu phí"
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <FeeScheduleHistory
        posDeviceId={posDeviceId}
        cardTypeId={cardTypeId}
        cardTypeName={cardTypeName}
        bankId={bankId}
        bankName={bankName}
      />
    </Modal>
  );
};

export default FeeScheduleHistoryModal;
